"use client";

import { Wrapper } from "./components/wrapper";
import { LayoutProvider } from "./components/context";
import { useTranslations } from "next-intl";
import { getLayout30Menus } from "@/config/layout-30-navigation";
import type { Layout30Settings } from "./components/context";

export function Layout30({
  children,
  settings,
}: {
  children: React.ReactNode;
  settings?: Layout30Settings;
}) {
  const t = useTranslations("layout30");
  const defaultMenus = getLayout30Menus("workspace");

  return (
    <LayoutProvider
      settings={
        settings ?? {
          audience: "workspace",
          primaryMenu: defaultMenus.primary,
          sectionMenu: defaultMenus.sections,
        }
      }
      style={
        {
          "--header-height": "60px",
          "--sidebar-width": "60px",
          "--sidebar-menu-width": "240px",
          "--layout-background":
            "color-mix(in oklab, var(--muted) 30%, var(--background))",
        } as React.CSSProperties
      }
    >
      <button
        type="button"
        onClick={() => document.getElementById("layout-content")?.focus()}
        className="sr-only z-50 rounded-md bg-background px-3 py-2 text-sm font-medium text-foreground shadow-md focus:not-sr-only focus:fixed focus:start-3 focus:top-3"
      >
        {t(
          settings?.audience === "supplier"
            ? "supplierSkipToContent"
            : "skipToContent",
        )}
      </button>
      <Wrapper>{children}</Wrapper>
    </LayoutProvider>
  );
}
